import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/dahsboard/actions",
        name: "dashboard_actions",
        component: () => import("@/views/apps/dashboard/ActionsIndicateur.vue"),
      },
      {
        path: "/notification",
        name: "apps-notification-list",
        component: () => import("@/views/notification/NotificationList.vue"),
      },
      {
        name: "apps-suivi-list",
        path: "/apps/suivi/list",
        component: () => import("@/views/apps/suivi/SuiviEquipment.vue"),
      },
      {
        name: "apps-suivi-sous-traitant",
        path: "/apps/suivi/sous-traitant",
        component: () => import("@/views/apps/suivi/SousTraitant.vue"),
      },
      {
        name: "apps-suivi-add-achat",
        path: "/apps/suivi/achat/add",
        component: () => import("@/views/apps/suivi/AddAchat.vue"),
      },
      {
        name: "apps-suivi-edit-achat",
        path: "/apps/suivi/achat/edit/:id",
        component: () => import("@/views/apps/suivi/AddAchat.vue"),
      },
      {
        name: "apps-suivi-monitoring",
        path: "/apps/suivi/monitoring",
        component: () => import("@/views/apps/suivi/EquipmentMonitoring.vue"),
      },
      {
        name: "apps-dechet-bordereau",
        path: "/apps/dechet/bordereau",
        component: () => import("@/views/apps/dechets/DechetBordereau.vue"),
      },
      {
        name: "apps-dechet-list",
        path: "/apps/dechet/list",
        component: () => import("@/views/apps/dechets/DechetList.vue"),
      },
      {
        name: "apps-dechet-month",
        path: "/apps/dechet/month",
        component: () => import("@/views/apps/dechets/DechetMonth.vue"),
      },
      {
        name: "apps-dechet-indicateur",
        path: "/apps/dechet/indicateur",
        component: () => import("@/views/apps/dechets/DechetIndicateur.vue"),
      },
      {
        name: "apps-audit-calendar",
        path: "/apps/audit/calendar",
        component: () => import("@/views/apps/audit/CalendrierAudit.vue"),
      },
      {
        name: "apps-audit-my-list",
        path: "/apps/audit/my-list",
        component: () => import("@/views/apps/audit/MesAudits.vue"),
      },
      {
        name: "apps-audit-rapport-list",
        path: "/apps/audit/list-rapport",
        component: () => import("@/views/apps/audit/RapportsList.vue"),
      },
      {
        name: "apps-audit-auditeur-list",
        path: "/apps/audit/list-auditeur",
        component: () => import("@/views/apps/audit/ListAuditeurs.vue"),
      },
      {
        name: "apps-audit-notation",
        path: "/apps/audit/notation",
        component: () => import("@/views/apps/audit/NotationAuditeur.vue"),
      },
      {
        name: "apps-audit-add-rapport",
        path: "/apps/audit/:id/add-rapport",
        component: () => import("@/views/apps/audit/NewRapport.vue"),
      },
      {
        name: "apps-audit-show-rapport",
        path: "/apps/audit/rapport/:id",
        component: () => import("@/views/apps/audit/ShowRapport.vue"),
      },
      {
        path: "/apps/incidents/analyse/:id",
        name: "apps-incident-analyse-show",
        component: () => import("@/views/apps/incidents/IncidentShow.vue"),
      },
      {
        path: "/apps/non-conformite/list",
        name: "apps-non-conformite-list",
        component: () =>
          import("@/views/apps/non-conformite/NonConformiteList.vue"),
      },
      {
        path: "/apps/non-conformite/add",
        name: "apps-non-conformite-add",
        component: () =>
          import("@/views/apps/non-conformite/NonConformiteForm.vue"),
      },
      {
        path: "/apps/non-conformite/list-action/:id?",
        name: "apps-non-conformite-list-action",
        component: () =>
          import("@/views/apps/non-conformite/PlanActionList.vue"),
      },
      {
        path: "/apps/non-conformite/show/:id",
        name: "apps-non-conformite-show",
        component: () =>
          import("@/views/apps/non-conformite/NonConformiteShow.vue"),
      },
      {
        path: "/apps/non-conformite/add-action",
        name: "apps-non-conformite-add-action",
        component: () => import("@/views/apps/non-conformite/AddAction.vue"),
      },
      {
        path: "/apps/non-conformite/:id_cause/add-action",
        name: "apps-non-conformite-add-action-id_cause",
        component: () => import("@/views/apps/non-conformite/AddAction.vue"),
      },
      {
        path: "/apps/non-conformite/edit-action/:id",
        name: "apps-non-conformite-edit-action",
        component: () => import("@/views/apps/non-conformite/EditAction.vue"),
      },
      {
        path: "/apps/non-conformite/indicateur",
        name: "apps-non-conformite-indicateur",
        component: () =>
          import("@/views/apps/non-conformite/IndicateurCharts.vue"),
      },
      {
        path: "/apps/incidents/flash-list",
        name: "apps-incident-flash-list",
        component: () => import("@/views/apps/incidents/FlashList.vue"),
      },
      {
        path: "/apps/incidents/flash/:id",
        name: "apps-incident-flash-show",
        component: () => import("@/views/apps/incidents/FlashShow.vue"),
      },
      {
        path: "/apps/incidents/add-flash",
        name: "apps-add-flash",
        component: () => import("@/views/apps/incidents/AddFlash.vue"),
      },
      {
        path: "/apps/incidents/edit-flash/:id",
        name: "apps-incident-edit-flash",
        component: () => import("@/views/apps/incidents/EditFlash.vue"),
      },
      {
        path: "/apps/incidents/add-analyse/:id?",
        name: "apps-incident-add-analyse",
        component: () => import("@/views/apps/incidents/AddAnalyse.vue"),
      },
      {
        path: "/apps/incidents/edit-analyse/:id",
        name: "apps-incident-edit-analyse",
        component: () => import("@/views/apps/incidents/EditAnalyse.vue"),
      },
      {
        path: "/apps/incidents/analyse-list/:id_flash?",
        name: "apps-incident-analyse-list",
        component: () => import("@/views/apps/incidents/AnalyseList.vue"),
      },
      {
        path: "/apps/incidents/registre-list",
        name: "apps-incident-registre-list",
        component: () =>
          import("@/views/apps/incidents/RegistreIncidentList.vue"),
      },
      {
        path: "/apps/incidents/indicateur-chart",
        name: "apps-indicateur-chart",
        component: () => import("@/views/apps/incidents/IndicateurChart.vue"),
      },
      {
        path: "/apps/incidents/add-action",
        name: "apps-incident-add-action",
        component: () => import("@/views/apps/incidents/AddAction.vue"),
      },
      {
        path: "/apps/incidents/:id_cause/add-action",
        name: "apps-incident-add-action-id_cause",
        component: () => import("@/views/apps/incidents/AddAction.vue"),
      },
      {
        path: "/apps/incidents/edit-action/:id",
        name: "apps-incident-edit-action-incident",
        component: () => import("@/views/apps/incidents/EditAction.vue"),
      },
      {
        path: "/apps/incidents/list-action/:id?",
        name: "apps-incident-list-action",
        component: () => import("@/views/apps/incidents/PlanActionList.vue"),
      },
      {
        path: "/apps/consumption/water-indicateur",
        name: "apps-consumption-water-indicateur",
        component: () => import("@/views/apps/consumption/IndicateurWater.vue"),
      },
      {
        path: "/apps/consumption/water-list",
        name: "apps-consumption-water-list",
        component: () =>
          import("@/views/apps/consumption/WaterConsumptionList.vue"),
      },
      {
        path: "/apps/consumption/water-action",
        name: "apps-consumption-water-action",
        component: () =>
          import("@/views/apps/consumption/PlanActionListWater.vue"),
      },
      {
        path: "/apps/consumption/water-add-action",
        name: "apps-consumption-water-add-action",
        component: () => import("@/views/apps/consumption/AddActionWater.vue"),
      },
      {
        path: "/apps/consumption/water-edit-action/:id",
        name: "apps-consumption-water-edit-action",
        component: () => import("@/views/apps/consumption/EditActionWater.vue"),
      },
      {
        path: "/apps/consumption/fuel-list",
        name: "apps-consumption-fuel-list",
        component: () =>
          import("@/views/apps/consumption/FuelConsumptionList.vue"),
      },
      {
        path: "/apps/consumption/fuel-indicateur",
        name: "apps-consumption-fuel-indicateur",
        component: () => import("@/views/apps/consumption/IndicateurFuel.vue"),
      },
      {
        path: "/apps/consumption/fuel-action",
        name: "apps-consumption-fuel-action",
        component: () =>
          import("@/views/apps/consumption/PlanActionListFuel.vue"),
      },
      {
        path: "/apps/consumption/fuel-add-action",
        name: "apps-consumption-fuel-add-action",
        component: () => import("@/views/apps/consumption/AddActionFuel.vue"),
      },
      {
        path: "/apps/consumption/fuel-edit-action/:id",
        name: "apps-consumption-fuel-edit-action",
        component: () => import("@/views/apps/consumption/EditActionFuel.vue"),
      },
      {
        path: "/apps/consumption/electricity-list",
        name: "apps-consumption-electricity-list",
        component: () =>
          import("@/views/apps/consumption/ElectricityConsumptionList.vue"),
      },
      {
        path: "/apps/consumption/electricity-indicateur",
        name: "apps-consumption-electricity-indicateur",
        component: () =>
          import("@/views/apps/consumption/IndicateurElectricity.vue"),
      },
      {
        path: "/apps/consumption/electricity-action",
        name: "apps-consumption-electricity-action",
        component: () =>
          import("@/views/apps/consumption/PlanActionListElectricity.vue"),
      },
      {
        path: "/apps/consumption/electricity-add-action",
        name: "apps-consumption-electricity-add-action",
        component: () =>
          import("@/views/apps/consumption/AddActionElectricity.vue"),
      },
      {
        path: "/apps/consumption/electricity-edit-action/:id",
        name: "apps-consumption-electricity-edit-action",
        component: () =>
          import("@/views/apps/consumption/EditActionElectricity.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-list",
        name: "apps-monitoring-list",
        component: () => import("@/views/apps/monitoring/MonitoringList.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-add",
        name: "apps-monitoring-add",
        component: () => import("@/views/apps/monitoring/AddMonitoring.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-edit/:id",
        name: "apps-monitoring-edit",
        component: () => import("@/views/apps/monitoring/AddMonitoring.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-show/:id",
        name: "apps-monitoring-show",
        component: () => import("@/views/apps/monitoring/MonitoringShow.vue"),
      },
      {
        path: "/apps/monitoring/point-list",
        name: "apps-monitoring-point-list",
        component: () =>
          import("@/views/apps/monitoring/AnalyseMonitoringList.vue"),
      },
      {
        path: "/apps/monitoring/indicateur-chart",
        name: "apps-monitoring-indicateur-chart",
        component: () => import("@/views/apps/monitoring/IndicateurCharts.vue"),
      },
      {
        path: "/apps/point/:id_pt/add-action",
        name: "apps-point-add-action-id_pt",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/add-action",
        name: "apps-point-add-action",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/edit-action-point/:id",
        name: "apps-point-edit-action-point",
        component: () => import("@/views/apps/monitoring/EditAction.vue"),
      },
      {
        path: "/apps/point/add-action-point/:id_pt",
        name: "apps-point-add-action-point",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/list-action/:id?",
        name: "apps-point-list-action",
        component: () => import("@/views/apps/monitoring/PlanActionList.vue"),
      },
      {
        path: "/apps/analyse/indicateur-chart",
        name: "apps-analyse-indicateur-chart",
        component: () => import("@/views/apps/analyse/IndicateurCharts.vue"),
        meta: {
          roles: [
            "Superadmin",
            "Management",
            "RSE Manager",
            "RSE Supervisor",
            "Others",
          ],
        },
      },
      {
        path: "/apps/analyse/analyse-env-list",
        name: "apps-analyse-analyse-env-list",
        component: () => import("@/views/apps/analyse/AnalyseEnvList.vue"),
      },
      {
        path: "/apps/analyse/add-analyse",
        name: "apps-analyse-add-analyse",
        component: () => import("@/views/apps/analyse/AddAnalyse.vue"),
      },
      {
        path: "/apps/analyse/add-action",
        name: "apps-analyse-add-action",
        component: () => import("@/views/apps/analyse/AddActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/add-action-analyse/:id",
        name: "apps-analyse-add-action-analyse",
        component: () => import("@/views/apps/analyse/AddActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/edit-action-analyse/:id",
        name: "apps-analyse-edit-action-analyse",
        component: () => import("@/views/apps/analyse/EditActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/list-action/:id?",
        name: "apps-analyse-list-action",
        component: () => import("@/views/apps/analyse/PlanActionList.vue"),
      },
      {
        path: "/apps/analyse/show-analyse/:id",
        name: "apps-analyse-show-analyse",
        component: () => import("@/views/apps/analyse/AnalyseEnvShow.vue"),
      },
      {
        path: "/apps/analyse/edit-analyse/:id",
        name: "apps-analyse-edit-analyse",
        component: () => import("@/views/apps/analyse/AddAnalyse.vue"),
      },
      {
        path: "/apps/reglementation/indicateur-chart",
        name: "apps-reglementation-indicateur-chart",
        component: () =>
          import("@/views/apps/reglementation/IndicateurCharts.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-list",
        name: "apps-reglementation-reglementation-list",
        component: () =>
          import("@/views/apps/reglementation/ReglementationList.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-add",
        name: "apps-reglementation-reglementation-add",
        component: () =>
          import("@/views/apps/reglementation/AddReglementation.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-show/:id",
        name: "apps-reglementation-reglementation-show",
        component: () =>
          import("@/views/apps/reglementation/ReglementationShow.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-edit/:id",
        name: "apps-reglementation-reglementation-edit",
        component: () =>
          import("@/views/apps/reglementation/AddReglementation.vue"),
      },
      {
        path: "/apps/reglementation/:id_reg/add-action",
        name: "apps-reglementation-add-action-id_reg",
        component: () => import("@/views/apps/reglementation/AddAction.vue"),
      },
      {
        path: "/apps/reglementation/add-action",
        name: "apps-reglementation-add-action",
        component: () => import("@/views/apps/reglementation/AddAction.vue"),
      },
      {
        path: "/apps/reglementation/edit-action-reglementation/:id",
        name: "apps-reglementation-edit-action-reglementation",
        component: () => import("@/views/apps/reglementation/EditAction.vue"),
      },
      {
        path: "/apps/reglementation/list-action/:id?",
        name: "apps-reglementation-list-action",
        component: () =>
          import("@/views/apps/reglementation/PlanActionList.vue"),
      },
      {
        path: "/apps/settings/add-settings",
        name: "apps-settings-add-list",
        component: () => import("@/views/apps/settings/AddSettings.vue"),
      },
      {
        path: "/apps/settings/permission-settings",
        name: "apps-settings-permission-list",
        component: () => import("@/views/apps/settings/PermissionSettings.vue"),
      },
      {
        path: "/apps/account/profile",
        name: "apps-user-profile",
        component: () => import("@/views/apps/account/UserShow.vue"),
      },
      {
        path: "/apps/users/users-dashboard",
        name: "apps-users-dashboard",
        component: () => import("@/views/apps/users/UsersDashboard.vue"),
      },
      {
        path: "/apps/users/users-show",
        name: "apps-users-show",
        component: () => import("@/views/apps/users/UsersShow.vue"),
      },
      {
        path: "/apps/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/apps/chat/DrawerChat.vue"),
      },
      {
        path: "/crafted/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () =>
          import("@/views/crafted/modals/general/InviteFriends.vue"),
      },
      {
        path: "/crafted/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/crafted/modals/general/ViewUsers.vue"),
      },
      {
        path: "/crafted/modals/general/upgrade-plan",
        name: "modals-general-upgrade-plan",
        component: () =>
          import("@/views/crafted/modals/general/UpgradePlan.vue"),
      },
      {
        path: "/crafted/modals/general/share-and-earn",
        name: "modals-general-share-and-earn",
        component: () =>
          import("@/views/crafted/modals/general/ShareAndEarn.vue"),
      },
      {
        path: "/crafted/modals/forms/new-target",
        name: "modals-forms-new-target",
        component: () => import("@/views/crafted/modals/forms/NewTarget.vue"),
      },
      {
        path: "/crafted/modals/forms/new-card",
        name: "modals-forms-new-card",
        component: () => import("@/views/crafted/modals/forms/NewCard.vue"),
      },
      {
        path: "/crafted/modals/forms/new-address",
        name: "modals-forms-new-address",
        component: () => import("@/views/crafted/modals/forms/NewAddress.vue"),
      },
      {
        path: "/crafted/modals/forms/create-api-key",
        name: "modals-forms-create-api-key",
        component: () =>
          import("@/views/crafted/modals/forms/CreateApiKey.vue"),
      },
      {
        path: "/crafted/modals/wizards/two-factor-auth",
        name: "modals-wizards-two-factor-auth",
        component: () =>
          import("@/views/crafted/modals/wizards/TwoFactorAuth.vue"),
      },
      {
        path: "/crafted/modals/wizards/create-app",
        name: "modals-wizards-create-app",
        component: () => import("@/views/crafted/modals/wizards/CreateApp.vue"),
      },
      {
        path: "/crafted/modals/wizards/create-account",
        name: "modals-wizards-create-account",
        component: () =>
          import("@/views/crafted/modals/wizards/CreateAccount.vue"),
      },
      {
        path: "/crafted/widgets/lists",
        name: "widgets-list",
        component: () => import("@/views/crafted/widgets/Lists.vue"),
      },
      {
        path: "/crafted/widgets/statistics",
        name: "widgets-statistics",
        component: () => import("@/views/crafted/widgets/Statistics.vue"),
      },
      {
        path: "/crafted/widgets/charts",
        name: "widgets-charts",
        component: () => import("@/views/crafted/widgets/Charts.vue"),
      },
      {
        path: "/crafted/widgets/mixed",
        name: "widgets-mixed",
        component: () => import("@/views/crafted/widgets/Mixed.vue"),
      },
      {
        path: "/crafted/widgets/tables",
        name: "widgets-tables",
        component: () => import("@/views/crafted/widgets/Tables.vue"),
      },
      {
        path: "/crafted/widgets/feeds",
        name: "widgets-feeds",
        component: () => import("@/views/crafted/widgets/Feeds.vue"),
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/Builder.vue"),
      },
      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/components/page-layouts/Profile.vue"),
        children: [
          {
            path: "projects",
            name: "profile-projects",
            component: () =>
              import("@/views/crafted/pages/profile/Projects.vue"),
          },
          {
            path: "campaigns",
            name: "profile-campaigns",
            component: () =>
              import("@/views/crafted/pages/profile/Campaigns.vue"),
          },
          {
            path: "documents",
            name: "profile-documents",
            component: () =>
              import("@/views/crafted/pages/profile/Documents.vue"),
          },
          {
            path: "connections",
            name: "profile-connections",
            component: () =>
              import("@/views/crafted/pages/profile/Connections.vue"),
          },
          {
            path: "activity",
            name: "profile-activity",
            component: () =>
              import("@/views/crafted/pages/profile/Activity.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  setTimeout(() => {
    // const userRole = store.state.AuthModule.user.role.name;
    // const allowedRoles = (to.meta as { roles?: string[] }).roles; // Add type assertion for to.meta
    if (!store.state.AuthModule.isAuthenticated && to.name !== "sign-in") {
      next({ name: "sign-in" });
    } else {
      next();
    }
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
